export const gradientColors = {
  red: {
    background:
      "bg-gradient-to-br from-gray-50 to-red-50 dark:from-gray-900 dark:to-red-900",
    border:
      "bg-gradient-to-r from-red-600 to-orange-600 dark:from-red-400 dark:to-orange-400",
    textColor: "text-red-600 dark:text-red-400",
    textCompleted: "text-green-600 dark:text-green-400",
  },
  orange: {
    background:
      "bg-gradient-to-br from-gray-50 to-orange-50 dark:from-gray-900 dark:to-orange-900",
    border:
      "bg-gradient-to-r from-orange-600 to-red-600 dark:from-orange-400 dark:to-red-400",
    textColor: "text-orange-600 dark:text-orange-400",
    textCompleted: "text-green-600 dark:text-green-400",
  },
  blue: {
    background:
      "bg-gradient-to-br from-gray-50 to-blue-50 dark:from-gray-900 dark:to-blue-900",
    border:
      "bg-gradient-to-r from-blue-600 to-indigo-600 dark:from-blue-400 dark:to-indigo-400",
    textColor: "text-blue-600 dark:text-blue-400",
    textCompleted: "text-green-600 dark:text-green-400",
  },
  teal: {
    background:
      "bg-gradient-to-br from-gray-50 to-teal-50 dark:from-gray-900 dark:to-teal-900",
    border:
      "bg-gradient-to-r from-teal-600 to-emerald-600 dark:from-teal-400 dark:to-emerald-400",
    textColor: "text-teal-600 dark:text-teal-400",
    textCompleted: "text-green-600 dark:text-green-400",
  },
  cyan: {
    background:
      "bg-gradient-to-br from-gray-50 to-cyan-50 dark:from-gray-900 dark:to-cyan-900",
    border:
      "bg-gradient-to-r from-cyan-600 to-cyan-500 dark:from-cyan-400 dark:to-cyan-300",
    textColor: "text-cyan-600 dark:text-cyan-400",
    textCompleted: "text-green-600 dark:text-green-400",
  },
  rose: {
    background:
      "bg-gradient-to-br from-gray-50 to-rose-50 dark:from-gray-900 dark:to-rose-900",
    border:
      "bg-gradient-to-r from-rose-600 to-red-600 dark:from-rose-400 dark:to-red-400",
    textColor: "text-rose-600 dark:text-rose-400",
    textCompleted: "text-green-600 dark:text-green-400",
  },
  stone: {
    background:
      "bg-gradient-to-br from-gray-50 to-stone-50 dark:from-gray-900 dark:to-stone-900",
    border:
      "bg-gradient-to-r from-stone-600 to-stone-500 dark:from-stone-400 dark:to-stone-300",
    textColor: "text-stone-600 dark:text-stone-400",
    textCompleted: "text-green-600 dark:text-green-400",
  },
  lime: {
    background:
      "bg-gradient-to-br from-gray-50 to-lime-50 dark:from-gray-900 dark:to-lime-900",
    border:
      "bg-gradient-to-r from-lime-600 to-lime-500 dark:from-lime-400 dark:to-lime-300",
    textColor: "text-lime-600 dark:text-lime-400",
    textCompleted: "text-green-600 dark:text-green-400",
  },
  terra: {
    background:
      "bg-gradient-to-br from-gray-50 to-[#FFF6F6] dark:from-gray-900 dark:to-[#4D2828]",
    border:
      "bg-gradient-to-r from-[#D98787] to-[#C65151] dark:from-[#E9A3A3] dark:to-[#D67272]",
    textColor: "text-[#C65151] dark:text-[#E9A3A3]",
    textCompleted: "text-green-600 dark:text-green-400",
  },
  purple: {
    background:
      "bg-gradient-to-br from-purple-50 to-purple-50 dark:from-purple-900 dark:to-purple-900",
    border:
      "bg-gradient-to-r from-purple-600 to-purple-500 dark:from-purple-400 dark:to-purple-300",
    textColor: "text-purple-600 dark:text-purple-400",
    textCompleted: "text-green-600 dark:text-green-400",
  },
  amber: {
    background:
      "bg-gradient-to-br from-gray-50 to-amber-50 dark:from-gray-900 dark:to-amber-900",
    border:
      "bg-gradient-to-r from-amber-600 to-yellow-600 dark:from-amber-400 dark:to-yellow-400",
    textColor: "text-amber-600 dark:text-amber-400",
    textCompleted: "text-green-600 dark:text-green-400",
  },
  emerald: {
    background:
      "bg-gradient-to-br from-gray-50 to-emerald-50 dark:from-gray-900 dark:to-emerald-900",
    border:
      "bg-gradient-to-r from-emerald-600 to-green-600 dark:from-emerald-400 dark:to-green-400",
    textColor: "text-emerald-600 dark:text-emerald-400",
    textCompleted: "text-green-600 dark:text-green-400",
  },
  violet: {
    background:
      "bg-gradient-to-br from-gray-50 to-violet-50 dark:from-gray-900 dark:to-violet-900",
    border:
      "bg-gradient-to-r from-violet-600 to-purple-600 dark:from-violet-400 dark:to-purple-400",
    textColor: "text-violet-600 dark:text-violet-400",
    textCompleted: "text-green-600 dark:text-green-400",
  },
  slate: {
    background:
      "bg-gradient-to-br from-gray-50 to-slate-50 dark:from-gray-900 dark:to-slate-900",
    border:
      "bg-gradient-to-r from-slate-600 to-slate-500 dark:from-slate-400 dark:to-slate-300",
    textColor: "text-slate-600 dark:text-slate-400",
    textCompleted: "text-green-600 dark:text-green-400",
  },
  yellow: {
    background:
      "bg-gradient-to-br from-gray-50 to-yellow-50 dark:from-gray-900 dark:to-yellow-900",
    border:
      "bg-gradient-to-r from-yellow-600 to-amber-600 dark:from-yellow-400 dark:to-amber-400",
    textColor: "text-yellow-600 dark:text-yellow-400",
    textCompleted: "text-green-600 dark:text-green-400",
  },
  fuchsia: {
    background:
      "bg-gradient-to-br from-gray-50 to-fuchsia-50 dark:from-gray-900 dark:to-fuchsia-900",
    border:
      "bg-gradient-to-r from-fuchsia-600 to-pink-600 dark:from-fuchsia-400 dark:to-pink-400",
    textColor: "text-fuchsia-600 dark:text-fuchsia-400",
    textCompleted: "text-green-600 dark:text-green-400",
  },
  sage: {
    background:
      "bg-gradient-to-br from-gray-50 to-[#E8F1EB] dark:from-gray-900 dark:to-[#2A3E33]",
    border:
      "bg-gradient-to-r from-[#7EA88E] to-[#4A7759] dark:from-[#98C4A8] dark:to-[#5E8C6F]",
    textColor: "text-[#4A7759] dark:text-[#98C4A8]",
    textCompleted: "text-green-600 dark:text-green-400",
  },
  zinc: {
    background:
      "bg-gradient-to-br from-gray-50 to-zinc-50 dark:from-gray-900 dark:to-zinc-900",
    border:
      "bg-gradient-to-r from-zinc-600 to-zinc-500 dark:from-zinc-400 dark:to-zinc-300",
    textColor: "text-zinc-600 dark:text-zinc-400",
    textCompleted: "text-green-600 dark:text-green-400",
  },
  green: {
    background:
      "bg-gradient-to-br from-gray-50 to-green-50 dark:from-gray-900 dark:to-green-900",
    border:
      "bg-gradient-to-r from-green-600 to-emerald-600 dark:from-green-400 dark:to-emerald-400",
    textColor: "text-green-600 dark:text-green-400",
    textCompleted: "text-green-600 dark:text-green-400",
  },
  coral: {
    background:
      "bg-gradient-to-br from-gray-50 to-red-50 dark:from-gray-900 dark:to-red-900",
    border:
      "bg-gradient-to-r from-red-400 to-pink-500 dark:from-red-300 dark:to-pink-400",
    textColor: "text-red-400 dark:text-red-300",
    textCompleted: "text-green-600 dark:text-green-400",
  },
  mint: {
    background:
      "bg-gradient-to-br from-gray-50 to-green-50 dark:from-gray-900 dark:to-green-900",
    border:
      "bg-gradient-to-r from-green-400 to-teal-500 dark:from-green-300 dark:to-teal-400",
    textColor: "text-green-400 dark:text-green-300",
    textCompleted: "text-green-600 dark:text-green-400",
  },
  lavender: {
    background:
      "bg-gradient-to-br from-gray-50 to-purple-50 dark:from-gray-900 dark:to-purple-900",
    border:
      "bg-gradient-to-r from-purple-400 to-indigo-500 dark:from-purple-300 dark:to-indigo-400",
    textColor: "text-purple-400 dark:text-purple-300",
    textCompleted: "text-green-600 dark:text-green-400",
  },
  sunset: {
    background:
      "bg-gradient-to-br from-gray-50 to-orange-50 dark:from-gray-900 dark:to-orange-900",
    border:
      "bg-gradient-to-r from-orange-400 to-rose-500 dark:from-orange-300 dark:to-rose-400",
    textColor: "text-orange-400 dark:text-orange-300",
    textCompleted: "text-green-600 dark:text-green-400",
  },
  ocean: {
    background:
      "bg-gradient-to-br from-gray-50 to-blue-50 dark:from-gray-900 dark:to-blue-900",
    border:
      "bg-gradient-to-r from-blue-400 to-cyan-500 dark:from-blue-300 dark:to-cyan-400",
    textColor: "text-blue-400 dark:text-blue-300",
    textCompleted: "text-green-600 dark:text-green-400",
  },
  cream: {
    background:
      "bg-gradient-to-br from-gray-50 to-[#F0E8DF] dark:from-gray-900 dark:to-[#A89078]",
    border:
      "bg-gradient-to-r from-[#BFA58A] to-[#A07E5E] dark:from-[#C8B08D] dark:to-[#8B6F50]",
    textColor: "text-[#8D6B4E] dark:text-[#C8B08D]",
    textCompleted: "text-green-600 dark:text-green-400",
  },
  bloom: {
    background:
      "bg-gradient-to-br from-gray-50 to-yellow-50 dark:from-gray-900 dark:to-yellow-900",
    border:
      "bg-gradient-to-r from-[#F3C969] to-[#81C784] dark:from-[#FFD54F] dark:to-[#66BB6A]",
    textColor: "text-[#F3C969] dark:text-[#FFD54F]",
    textCompleted: "text-green-600 dark:text-green-400",
  },
} as const;

export type ThemeColor = keyof typeof gradientColors;
